const emailVerification = {
  title: "Email Verification",
  notice: {
    title: "Verification Required",
    sentTo: "A 6-digit verification code has been sent to:",
  },
  form: {
    codeLabel: "Verification Code:",
    codePlaceholder: "000000",
    codeHint: "Enter the 6-digit code from your email",
  },
  resendSuccess: "Verification code resent successfully!",
  verifying: "Verifying...",
  verify: "Verify Email",
  resending: "Sending...",
  resendCode: "Resend Code",
  help: {
    title: "Didn't receive the code?",
    checkSpam: "Check your spam/junk folder",
    checkEmail: "Make sure the email address is correct",
    clickResend: "Click \"Resend Code\" to try again",
    contactAdmin: "Contact your administrator if you continue to have issues",
  },
  errors: {
    invalidCode: "Please enter a 6-digit verification code",
    verificationFailed: "Verification failed",
    resendFailed: "Failed to resend code",
  },
};

export default emailVerification;
